module.exports = __webpack_public_path__ + "static/img/stJohns3.5e727a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/stJohns3.jpg
// module id = 137
// module chunks = 9